/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const Diamond = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 18 14" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M18 4.93a.71.71 0 0 0-.06-.28.74.74 0 0 0-.17-.25L13.66.23a.76.76 0 0 0-.55-.23H4.89a.75.75 0 0 0-.55.23L.23 4.38a.74.74 0 0 0-.17.25.72.72 0 0 0-.06.29.72.72 0 0 0 .06.29.72.72 0 0 0 .16.25l8.22 8.29a.69.69 0 0 0 .2.13h.06a.7.7 0 0 0 .52 0h.06a.69.69 0 0 0 .2-.13l8.22-8.29a.82.82 0 0 0 .3-.53zM4.31 5.7l1.76 3.47L2.63 5.7zM6 5.7h6l-3 5.82zm7.65 0h1.68l-3.4 3.47zm1.68-1.55h-1.7l-1.5-2.59h.62zm-5-2.59l1.5 2.59H6.12l1.5-2.59zm-5.17 0h.62L4.33 4.15h-1.7z" />
      </g>
    </svg>
  </span>
);

Diamond.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

Diamond.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default Diamond;
